import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppData } from "../context/AppDataContext"; 

function ProtectedLayout() {
  // Grab the global state instead of fetching locally
  const { user, loading, isDeactivating } = useAppData();

  // If the AppDataContext is still fetching the initial user data, show the spinner
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner-large"></div>
        <p className="loading-text">Verifying Session...</p>
      </div>
    );
  }

  // If loading is finished and there is no user, redirect to login
  if (!user && !loading && !isDeactivating) { 
      return <Navigate to="/login" replace />;
  }

  // User is authenticated
  return (
    <>
      <Navbar />
      <div className="layout-content">
        <Outlet />
      </div>
    </>
  );
}

export default ProtectedLayout;